module.exports = __webpack_public_path__ + "media/dashboard/assets/images/document-02707cef53c4a1bb499bf3cc57fa1e55.svg";